import { useState, useEffect, useContext, memo } from 'react';
import Link from 'next/link';

import { GlobalContext } from '@/contexts/GlobalContext';
import { AuthContext } from '@/contexts/AuthContext';

import styles from "@/styles/layout.module.scss";

const NavBar = () => {
    const { globalState: { vhInfo } } = useContext(GlobalContext);
    const { authState: { isAdminAuth } } = useContext(AuthContext);
    const [partsLink, setPartsLink] = useState<string>("/car-parts");

    useEffect(() => {
        if (vhInfo) {
            const make = vhInfo?.MAKE.toLowerCase().replace(/\s+|,\s/g, "-");
            const model = vhInfo?.MODEL1.toLowerCase().replace(/\s+|,\s/g, "-");

            setPartsLink(`/car-parts/${make}/${model.replace(/\//g, '-')}/${vhInfo.KCODE_B}`);
        }
    }, [vhInfo]);

    return (
        <div className={styles["nav-bar"]}>
            <ul className={styles["nav-list"]}>
                <li className={styles["nav-link"]}>
                    <Link href={partsLink}>
                        Car Parts
                    </Link>
                </li>
                <li className={styles["nav-link"]}>
                    <Link href="/search">
                        Search Parts
                    </Link>
                </li>
                <li className={styles["nav-link"]}>
                    <Link href="/blog">
                        Blog
                    </Link>
                </li>
                <li className={styles["nav-link"]}>
                    <Link href="/about">
                        About
                    </Link>
                </li>
                <li className={styles["nav-link"]}>
                    <Link href="/contact-us">
                        Contact Us
                    </Link>
                </li>
                {isAdminAuth && <li className={styles["nav-link--dashboard"]}>
                    <Link href="/admin/dashboard">
                        Dashboard
                    </Link>
                </li>}
            </ul>
        </div>
    );
};

export default memo(NavBar);
